import React from "react";
import { withTranslation } from "react-i18next";

const BackButton = ({ t, onBack }) => {
  const button = (
    <>
      <span className="ico">
        <img
          src={require("../../../../assets/images/arrow-back-icon.svg").default}
          alt="arrow"
        />
      </span>
      {t("back")}
    </>
  );

  return (
    <a href="#back" onClick={(e) => { e.preventDefault(); onBack(); }}>
      {button}
    </a>
  );
};

export default withTranslation()(BackButton);
